module.exports = __webpack_public_path__ + "static/media/KABN-LOGO.f9c38a82.png";